export enum CountyEnum {
  carlow = 'Co. Carlow',
  cavan = 'Co. Cavan',
  clare = 'Co. Clare',
  cork = 'Co. Cork',
  donegal = 'Co. Donegal',
  dublin1 = 'Dublin 1',
  dublin2 = 'Dublin 2',
  dublin3 = 'Dublin 3',
  dublin4 = 'Dublin 4',
  dublin5 = 'Dublin 5',
  dublin6 = 'Dublin 6',
  dublin6w = 'Dublin 6W',
  dublin7 = 'Dublin 7',
  dublin8 = 'Dublin 8',
  dublin9 = 'Dublin 9',
  dublin10 = 'Dublin 10',
  dublin11 = 'Dublin 11',
  dublin12 = 'Dublin 12',
  dublin13 = 'Dublin 13',
  dublin14 = 'Dublin 14',
  dublin15 = 'Dublin 15',
  dublin16 = 'Dublin 16',
  dublin17 = 'Dublin 17',
  dublin18 = 'Dublin 18',
  dublin20 = 'Dublin 20',
  dublin22 = 'Dublin 22',
  dublin24 = 'Dublin 24',
  galway = 'Co. Galway',
  kerry = 'Co. Kerry',
  kildare = 'Co. Kildare',
  kilkenny = 'Co. Kilkenny',
  laois = 'Co. Laois',
  leitrim = 'Co. Leitrim',
  limerick = 'Co. Limerick',
  longford = 'Co. Longford',
  louth = 'Co. Louth',
  mayo = 'Co. Mayo',
  meath = 'Co. Meath',
  monaghan = 'Co. Monaghan',
  offaly = 'Co. Offaly',
  roscommon = 'Co. Roscommon',
  sligo = 'Co. Sligo',
  tipperary = 'Co. Tipperary',
  waterford = 'Co. Waterford',
  westmeath = 'Co. Westmeath',
  wexford = 'Co. Wexford',
  wicklow = 'Co. Wicklow',
  other = 'Other',
}
